import React, { Component } from 'react';
import { connect } from 'react-redux';
import DocketParties from './DocketParties';
import DocketDocuments from './DocketDocuments';
import PendingRejectedDocuments from './PendingRejectedDocuments';
import moment from 'moment';
import { Modal } from "react-bootstrap";
import { Field } from 'react-redux-form';
import { getCookie } from "../../../../services/helper/Helper";
import { getDocketGeneralInfo,getRejectedPendingDocs,updatePrefernce } from '../../../../actions/docketGeneralInfoAction';
import { showHideModal, resetModalValues, showHideThankYouModal } from '../../../../actions/uiAction';
import 'react-datepicker/dist/react-datepicker.css';

class DocketGeneralInfo extends Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			showDocketTab:true,
		};
	}
	componentDidMount() {
		let value=getCookie(btoa("publicAccess"));
		this.docketno = atob(this.props.match.params.docketno);
		//console.log(this.docketno);
		this.props.getDocketGeneralInfo(this.docketno);
		
	}
	/* Nishant 15052024: added componentDidUpdate functionality to update users opt in/out status without page refresh*/
	componentDidUpdate(prevProps) {
		if (this.props.eServiceForm.e_services !== prevProps.eServiceForm.e_services && prevProps.eServiceForm.e_services!=='') {
		  this.props.getDocketGeneralInfo(this.docketno);
		}
	}
	handleTab(tab)
	{
		if (tab === 'docket') {
			this.setState({ showDocketTab: true });
		} else {
			this.setState({ showDocketTab: false });
			this.props.getRejectedPendingDocs(this.docketno);
		}
	}
	render() {
		const docketInfo = this.props.docketGeneralInfo.DocketInfo || [];
		const petitionerRespondentInfo = this.props.docketGeneralInfo.casetypestylingData;
		const cmaInfo = this.props.docketGeneralInfo.Cma || [];
		const judgeName = this.props.docketGeneralInfo.judgeName || [];
		const eServiceForm = this.props.eServiceForm || [];

		return (
			<div>
				<div className="overview-block">
					<div className="container">
						<div className="overview-wrapper">
							<div className="col-xs-4">
								<span>Docket Number</span>
								<span>{docketInfo ? docketInfo.docketnumber : '-'}</span>
							</div>
							<div className="col-xs-3">
								<span>Petitioner</span>
								<span>{docketInfo && docketInfo.petionerLastname != null ? docketInfo.petionerLastname + ', ' + docketInfo.petionerFirstname : petitionerRespondentInfo && petitionerRespondentInfo.petitioner!= null ? petitionerRespondentInfo.petitioner : '-'}</span>
							</div>
							<div className="col-xs-3">
								<span>Respondent</span>
								<span>{docketInfo && docketInfo.respondentLastname != null ? docketInfo.respondentLastname + ', ' + docketInfo.respondentFirstname : petitionerRespondentInfo && petitionerRespondentInfo.respondent!= null ? petitionerRespondentInfo.respondent : '-'}</span>
							</div>
							<div className="col-xs-2">
								<div className="overview-eservice-block">
									<span>eService preference</span>
									<div className="overview-optedtooltip">
										<i class="fa fa-info-circle" aria-hidden="true"></i>
										{/* <span className="tooltiptext" >By opting in to eService, you are consenting to receive all filings from the Court electronically.  You also consent for any opposing parties of record to serve you electronically through ePortal, and <b>you thereby waive the right to service by the means described under Ga. Comp. R. & Regs. 616-1-2-.11.</b>  Any service requirements otherwise provided by law shall remain in effect.</span> */}
										<span className="tooltiptext" >By opting in to eService, you consent for any opposing parties of record to serve you electronically through ePortal. Any service requirements otherwise provided by law shall remain in effect.</span>
									</div>	
								</div>
								<Field model="eServiceForm.e_services" className="overview-eservice-radio">
									<div className="radio-block" role="radiogroup" tabIndex="0">
										<span>
											<input role="radio" id="opt-in" aria-label="Opt-in"  name="preference" type="radio" className="field radio" value="1" onChange = {()=>{this.props.updatePrefernce('1',docketInfo.caseid)}} checked={eServiceForm.e_services=='1'} />
											<label className="" htmlFor="opt-in" >
												<span className="choice__text">Opt-in</span>
											</label>
										</span>
										<span>
											<input role="radio" id="opt-out" aria-label="Opt-out" name="preference" type="radio" className="field radio" value="0" onChange = {()=>{this.props.updatePrefernce('0',docketInfo.caseid)}} checked={eServiceForm.e_services=='0'}/>
											<label className="" htmlFor="opt-out" >
												<span className="choice__text">Opt-out</span>
											</label>
										</span>					
									</div>
								</Field>
							</div>
						</div>
					</div>
				</div>
				<div className="docket-information-block">
					<div className="tab-block">
						<div className="container">
							<ul>
								<li onClick={() => { this.handleTab("docket") }}>
									<a href="javascript:;" className={this.state.showDocketTab ? 'active' : ''}><i className="fa fa-info-circle" aria-hidden="true"></i> General Information</a>
								</li>
								<li onClick={() => { this.handleTab("document") }}>
									<a href="javascript:;" className={!this.state.showDocketTab ? 'active' : ''}><i className="fa fa-info-circle" aria-hidden="true"></i> Pending or Rejected Documents</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
				{this.state.showDocketTab ?<div className="docket-information-left col-xs-5">
					<div className="docket-info-block">
						<h2>Docket Information</h2>
						<div className="col-xs-3">
							<label>Agency Code</label>
							<span>{docketInfo.refagency}</span>
						</div>
						<div className="col-xs-3">
							<label>Case Type</label>
							<span>{docketInfo.casetype}</span>
						</div>
						<div className="col-xs-3">
							<label>County</label>
							<span>{docketInfo.county}</span>
						</div>
						<div className="col-xs-3">
							<label>Status</label>
							<span>{docketInfo.status}</span>
						</div>
					</div>
					<div className="hearing-info-block">
						<h2>Hearing Information</h2>
						<div className="col-xs-12">
							<label>Location</label>
							<span>{docketInfo.hearingsite != '' ? docketInfo.hearingsite : '-'}</span>
						</div>
						<div className="col-xs-6">
							<label>Hearing Date</label>
							<span>{docketInfo.hearingdate != null && docketInfo.hearingdate != '' ? docketInfo.hearingdate : '-'}</span>
						</div>
						<div className="col-xs-6">
							<label>Hearing Time</label>
							<span>{docketInfo.hearingtime != null && docketInfo.hearingtime != '' ? moment(docketInfo.hearingtime, 'HH:mm').format('hh:mm A') : '-'}</span>
						</div>
						<div className="col-xs-6">
							<label>Judge</label>
							<span>{judgeName}</span>
						</div>
						<div className="col-xs-6">
							<label>Assistant</label>
							<span>{cmaInfo.name}</span>
						</div>
					</div>
					<div className="additional-info-block">
						<h2>Additional Information</h2>
						<div className="col-xs-6">
							<label>Date Requested</label>
							<span>{docketInfo ? docketInfo.daterequested : '-'}</span>
						</div>
						<div className="col-xs-6">
							<label>Date Received</label>
							<span>{docketInfo ? docketInfo.datereceivedbyOSAH : '-'}</span>
						</div>
						<div className="col-xs-6">
							<label>Agency Reference Number</label>
							<span>{docketInfo.agencyrefnumber != '' && docketInfo.agencyrefnumber != null ? docketInfo.agencyrefnumber : '-'}</span>
						</div>
						<div className="col-xs-6">
							<label>Hearing Type</label>
							<span>{docketInfo.hearingmode != '' ? docketInfo.hearingmode : '-'}</span>
						</div>
					</div>
				</div> :<div></div>}
				{this.state.showDocketTab ?<div className="docket-information-right col-xs-7">
					<div className="docket-info-right-block">
						<div className="docket-info-top">
							<div className="col-xs-3">
								<label>Judge Assistant:</label>
								<span>{cmaInfo.name}</span>
							</div>
							<div className="col-xs-3">
								<label>Phone:</label>
								<span>{cmaInfo.phone}</span>
							</div>
							<div className="col-xs-6">
								<label>Email:</label>
								<span>{cmaInfo.email != '' ? cmaInfo.email : '-'}</span>
							</div>
						</div>
						<DocketDocuments/>
					</div>
					<DocketParties/>
				</div>:<div></div>}
		
			{!this.state.showDocketTab ? <PendingRejectedDocuments/> :<div></div>}
		</div>
		
		
		
		
				)
			}
		}
		
function mapStateToProps(state) {
  return {
				docketGeneralInfo : state.docketGeneralInfo,
				uploadFile : state.uploadFile,
				uiState : state.uiState,
				eServiceForm : state.eServiceForm
			};
		  }
		  
export default connect(mapStateToProps,{getDocketGeneralInfo,showHideModal,resetModalValues,showHideThankYouModal,getRejectedPendingDocs,updatePrefernce})(DocketGeneralInfo);